import { render } from "./SeatPlan.vue?vue&type=template&id=000f83e6&scoped=true"
import script from "./SeatPlan.vue?vue&type=script&lang=js"
export * from "./SeatPlan.vue?vue&type=script&lang=js"

import "./SeatPlan.vue?vue&type=style&index=0&id=000f83e6&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000f83e6"]])

export default __exports__